// stub for all platforms
const NOOP = () => {};

export const applyMonkeyPatch = NOOP;
export const revertMonkeyPatch = NOOP;
